import { IExecutionOptions } from '../models/query';
import { isArrayLike } from '../utils/isArrayLike';
import { IQueryOptionsProperty } from '../models/query/options';
import { BaseEntityQuery } from './BaseEntityQuery';

export class PropertyQuery extends BaseEntityQuery<IQueryOptionsProperty> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsProperty {
		const { entityType, entityConditional, code, codeQuery, key, keyQuery, index, options = {} } = this.queryOptions;
		return {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			index,
			...(options.property || {}),
		};
	}
	cleanPropertyIfArray = (property: any) => {
		const { index } = this.options;
		if (typeof index === 'number' && isArrayLike(property) && property[index]) {
			return property[index];
		}
		return property;
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key } = this.options;
		const entity = this.getEntity(executionOptions);
		const properties = entity && (entity.properties_pub || entity.properties);
		if (properties && properties[code]) {
			const property = properties[code][key || 'value'];
			return this.cleanPropertyIfArray(property);
		}
		return undefined;
	}
}
